import { render } from "./ExpirationLabel.vue?vue&type=template&id=3e1af0c5&scoped=true"
import script from "./ExpirationLabel.vue?vue&type=script&lang=js"
export * from "./ExpirationLabel.vue?vue&type=script&lang=js"

import "./ExpirationLabel.vue?vue&type=style&index=0&id=3e1af0c5&lang=scss&scoped=true"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1af0c5"]])

export default __exports__